module.exports = __webpack_public_path__ + "img/customer4.bbc36a6a.png";